import { Image } from "primereact/image"
import deleteButton from "../../assets/svg/delete_icon.svg"

export default function DeleteButton() {
    return (
        <Image src={deleteButton} imageClassName="mt-[1.5px] icon" />
    )
}